import React from 'react';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import InnerBanner from '../components/PagesComponents/InnerBanner';
import UserDetailInfo from '../components/AdminComponents/UserDetailInfo';
const AdminUserDetail = () => {
 return (
    <>
{/* <InnerBanner pageKey="adminUserDetail" /> */}

      <section className='dashboard'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                   <UserDetailInfo/> 
                </div>
               
            </div>
        </div>
      </section>
    </>
 );

};

export default AdminUserDetail;